// extracted by mini-css-extract-plugin
export default {"ccvLogoContainer":"leftColumn_ccvLogoContainer__XkvLp"};